import {
  closestCenter,
  DndContext,
  DragEndEvent,
  DragOverlay,
  DragStartEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import { useState } from 'react';
import TargetItem from 'components/RankingRule/TargetItem';
import SortableTargetItem from 'components/RankingRule/SortableTargetItem';
import { RankingRuleActionType } from 'types/ranking';

export default function DraggableContainer(props: {
  items: RankingRuleTargetBoostItem[] | RankingRuleTargetBuryItem[];
  type: RankingRuleActionType;
  handleItemReorder: (prevIdx: number, newIdx: number) => void;
  handleItemRemove: (
    item: RankingRuleTargetBoostItem | RankingRuleTargetBuryItem,
  ) => void;
}) {
  const { items, type, handleItemRemove, handleItemReorder } = props;
  const [activeId, setActiveId] = useState<string | null>(null);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const handleDragStart = (event: DragStartEvent) => {
    const { active } = event;
    setActiveId(active.id as string);
  };
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    const activeId = active.id.toString();
    const overId = over?.id.toString();
    if (activeId === overId) {
      return;
    }
    const oldIndex = items.findIndex(
      (item) => JSON.stringify(item) === activeId,
    );
    const newIndex = items.findIndex((item) => JSON.stringify(item) === overId);
    handleItemReorder(oldIndex, newIndex);
    setActiveId(null);
  };
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={items.map((item) => JSON.stringify(item))}>
        {items.map((data, idx) => {
          return (
            <SortableTargetItem
              key={JSON.stringify(data)}
              id={JSON.stringify(data)}
              data={data}
              actionType={type}
              onRemove={() => handleItemRemove(data)}
            />
          );
        })}
      </SortableContext>
      <DragOverlay>
        {activeId ? (
          <TargetItem
            data={items.find((item) => JSON.stringify(item) === activeId)!}
          />
        ) : null}
      </DragOverlay>
    </DndContext>
  );
}
